/** @module Enums */ /** typedoc */
/**
 * Noise reduction level used to master video tracks.
 */
var NoiseReductionLevelEnum;
(function (NoiseReductionLevelEnum) {
    NoiseReductionLevelEnum["Low"] = "Low";
    NoiseReductionLevelEnum["Medium"] = "Medium";
    NoiseReductionLevelEnum["High"] = "High";
})(NoiseReductionLevelEnum || (NoiseReductionLevelEnum = {}));

export { NoiseReductionLevelEnum };
